import {safeDefineElement} from "@/scripts/core/global";
import {ContentSidebar} from "@/scripts/optional/content-sidebar";

safeDefineElement(ContentSidebar)
